import './options-toolbar.scss'

import { defineComponent } from 'vue'
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons'

import { SearchParams, SortFilter } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

interface SortOption {
    label: string
    values: string[]
}

export const OptionsToolbar = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['sortingEntityFields'],
    template: require('./options-toolbar.html'),
    data() {
        return {
            sortOptions: [] as SortOption[],
            selectSortIndex: -1, // we set to -1 by default to trigger update after sortOptions are loaded
            // Icons
            sortAscIcon: faSortAmountUp,
            sortDescIcon: faSortAmountDown,
            options: {
                sortAsc: false,
                sortType: [''],
            } as Partial<SearchParams>,
        }
    },
    methods: {
        async populateSelectOptions() {
            this.sortOptions = []

            // Setting options from config file
            for (const [index, sortConfs] of (this.sortingEntityFields as SortFilter[])?.entries()) {
                const entityFieldsIds: string[] = []

                for(const sortConf of sortConfs.entityFields) {
                    try { // the try catch is to continue on error and not fail for all entityFields if one fail
                        if(sortConf.id) {
                            entityFieldsIds.push(sortConf.id)
                        }
                        else if(sortConf.entityFieldName && sortConf.entityName && sortConf.schemaName) {
                            const entityFieldId = await this.$entityFieldDataStore.getEntityFieldId(
                                sortConf.entityFieldName,
                                sortConf.entityName,
                                sortConf.schemaName
                            )
                            entityFieldsIds.push(entityFieldId)
                        }

                    } catch(err) {
                        //console.log(err)
                    }
                }

                this.sortOptions.push({
                    label: sortConfs.i18nKey,
                    values: entityFieldsIds
                })
            }

            // Setting default sort option (first in config file)
            if (this.sortOptions.length) {
                this.selectSortIndex = 0 // to trigger update
            }
        },
        toggleSortAsc() {
            this.options.sortAsc = !this.options.sortAsc
            this.$emit('change', this.options)
        },
    },
    watch: {
        selectSortIndex: {
            handler() {
                if(this.sortOptions?.[this.selectSortIndex]?.values?.length) {
                    this.options.sortType = this.sortOptions[this.selectSortIndex].values
                    this.$emit('change', this.options)
                }
            },
            immediate: true,
            deep: true,
        },
        sortingEntityFields() {
            this.populateSelectOptions()
        },
    },
})
